import {
    CHARTS_WHICH_NEED_ADJUSTMENT_FOR_RELEVANCE, EMOTION_OR_SENTIMENT_BAR_CHART_IDS,
    EMOTION_OR_SENTIMENT_MENTIONS_CHARTS_IDS, EMOTION_OR_THREE_CLASS_SENTIMENT_PIE_CHARTS_IDS,
    FIVE_CLASS_SENTIMENT_PIE_CHARTS_IDS, MENTIONS_LABEL, PARSE_INT_RADIX,
    UPDATE_SELECTED_CHART_DETAILS_AFTER_POST_RELEVANCE_UPDATES, EMOTION_PIE_CHART_ID, TOTAL,
    AVAILABLE_SOURCES_PIE_CHART_IDS, SENTIMENT_TREND_CHART_ID, EMOTION_OR_SENTIMENT_TREND_CHART_IDS,
    EMOTION_OR_SENTIMENT_PERCENTAGE_TREND_CHART_IDS, SENTIMENT_PERCENTAGE_TREND_CHART_ID,
    SUB_TOPIC_CLUSTERS_CHART_IDS
} from './constants';
import { 
    POSITIVE, NEGATIVE, NEUTRAL, JOY, ANGER, SADNESS, FEAR, VERY_POSITIVE, VERY_NEGATIVE,
    VERY_POSITIVE_KEY_FOR_CHART_COUNT_CHANGES, VERY_NEGATIVE_KEY_FOR_CHART_COUNT_CHANGES, 
    SENTIMENTS, EMOTIONS,
    NO_SPECIFIC_EMOTION
} from '../../../home/redux/constants';
  
export function updateChartForRelevanceUpdatesOfPost(chartId, postAfterRelevanceUpdates) {
    return dispatch => {
        dispatch({
            type: UPDATE_SELECTED_CHART_DETAILS_AFTER_POST_RELEVANCE_UPDATES,
            data: {
                chartId: chartId,
                postAfterRelevanceUpdates: postAfterRelevanceUpdates
            }
        });
    };
  }

export function reducer(state, action) {
    if (action.type !== UPDATE_SELECTED_CHART_DETAILS_AFTER_POST_RELEVANCE_UPDATES || !state) {
        return state;
    }
    const {
        chartId,
        postAfterRelevanceUpdates
    } = action.data;

    if (!shouldChartBeUpdated(state, chartId)) {
        return state;
    }

    const { 
        nonDateTimeSpecificChartCountsChanges,
        trendChartCountChanges,
        subTopicChartCountChanges,
        relevance,
        source
      } = postAfterRelevanceUpdates;
    const threeClassSentimentNonDateTimeSpecificChartCountChanges = getThreeClassSentimentNonDateTimeSpecificChartCountChanges(nonDateTimeSpecificChartCountsChanges);
  
    if (EMOTION_OR_SENTIMENT_MENTIONS_CHARTS_IDS.includes(chartId) && state[chartId].length > 0) {
        let newState = updateEmotionOrSentimentMentionsCharts(
            state,
            chartId,
            relevance,
            threeClassSentimentNonDateTimeSpecificChartCountChanges
        );
        return newState;
    }

    else if (EMOTION_OR_THREE_CLASS_SENTIMENT_PIE_CHARTS_IDS.includes(chartId) && state[chartId].data.length > 0) {
        let newState = updateEmotionOrSentimentPieCharts(
            state,
            chartId,
            relevance,
            threeClassSentimentNonDateTimeSpecificChartCountChanges
        );
        return newState;
    }

    else if (FIVE_CLASS_SENTIMENT_PIE_CHARTS_IDS.includes(chartId) && state[chartId].data.length > 0) {
        let newState = updateEmotionOrSentimentPieCharts(
            state,
            chartId,
            relevance,
            nonDateTimeSpecificChartCountsChanges
        );
        return newState;
    }

    else if (AVAILABLE_SOURCES_PIE_CHART_IDS.includes(chartId) && state[chartId].data.length > 0){
        let newState = updateAvailableSourcesPieChart(
            state,
            chartId,
            relevance,
            source,
            nonDateTimeSpecificChartCountsChanges
        );
        return newState;
    }
    
    else if (EMOTION_OR_SENTIMENT_BAR_CHART_IDS.includes(chartId) && state[chartId].values.length > 0){
        let newState = updateEmotionOrSentimentBarCharts (
            state,
            chartId,
            relevance,
            nonDateTimeSpecificChartCountsChanges
        );
        return newState;
    }

    else if (isTrendOrPercentageTrendChartWithData(chartId, state)) {
        let newState = updateEmotionOrSentimentTrendCharts(
            state,
            chartId,
            relevance,
            trendChartCountChanges
        );
        return newState;
    }

    else if (isSubTopicClustersChartWithData(chartId, state)) {
        let newState = updateSubTopicClustersChart(
            state,
            chartId,
            relevance,
            subTopicChartCountChanges
        );
        return newState;
    }
    return state;
}

export function shouldChartBeUpdated(state, chartId) {
    return (state.hasOwnProperty(chartId)) && CHARTS_WHICH_NEED_ADJUSTMENT_FOR_RELEVANCE.includes(chartId);
}

export function getThreeClassSentimentNonDateTimeSpecificChartCountChanges (nonDateTimeSpecificChartCountsChanges) {
    const threeClassSentimentNonDateTimeSpecificChartCountChanges = {
        [TOTAL]: nonDateTimeSpecificChartCountsChanges[TOTAL],
        [POSITIVE]: nonDateTimeSpecificChartCountsChanges[POSITIVE] + nonDateTimeSpecificChartCountsChanges[VERY_POSITIVE_KEY_FOR_CHART_COUNT_CHANGES],
        [NEGATIVE]: nonDateTimeSpecificChartCountsChanges[NEGATIVE] + nonDateTimeSpecificChartCountsChanges[VERY_NEGATIVE_KEY_FOR_CHART_COUNT_CHANGES],
        [NEUTRAL]: nonDateTimeSpecificChartCountsChanges[NEUTRAL],
        [JOY]: nonDateTimeSpecificChartCountsChanges[JOY],
        [ANGER]: nonDateTimeSpecificChartCountsChanges[ANGER],
        [SADNESS]: nonDateTimeSpecificChartCountsChanges[SADNESS],
        [FEAR]: nonDateTimeSpecificChartCountsChanges[FEAR]
    };
    return threeClassSentimentNonDateTimeSpecificChartCountChanges;
}

export function updateEmotionOrSentimentMentionsCharts(
    state,
    chartId,
    relevance,
    threeClassSentimentNonDateTimeSpecificChartCountChanges
) {
    let newState = JSON.parse(JSON.stringify(state));
    for (const element of newState[chartId]) {
        if (relevance) {
            element.count = parseInt(element.count, PARSE_INT_RADIX) + parseInt(threeClassSentimentNonDateTimeSpecificChartCountChanges[element.category], PARSE_INT_RADIX);
        }
        else {
            element.count = parseInt(element.count, PARSE_INT_RADIX) - parseInt(threeClassSentimentNonDateTimeSpecificChartCountChanges[element.category], PARSE_INT_RADIX);
        }
    }
    return newState;
}

export function updateEmotionOrSentimentPieCharts(
    state,
    chartId,
    relevance,
    nonDateTimeSpecificChartCountsChanges
    ) {
    let newState = JSON.parse(JSON.stringify(state));
    for (const categoryElement of newState[chartId].data) {
        const correspondingCountKeyForPieChartCategory = getCorrespondingCountKeyForPieChartCategory(categoryElement[0].toLowerCase());
        const countToUpdateChart = nonDateTimeSpecificChartCountsChanges[correspondingCountKeyForPieChartCategory];
        if (relevance) {
            categoryElement[1] = parseInt(categoryElement[1], PARSE_INT_RADIX) + countToUpdateChart;
        }
        else {
            categoryElement[1] = parseInt(categoryElement[1], PARSE_INT_RADIX) - countToUpdateChart;
        }  
    }

    if (chartId === EMOTION_PIE_CHART_ID) {
        newState = updateEmotionPieChartTotalCount(
            newState,
            chartId,
            relevance,
            nonDateTimeSpecificChartCountsChanges
        );
    }
    else {
        newState = updateSentimentAndAvailableSourcesPieChartsTotalCount(
            newState,
            chartId,
            relevance,
            nonDateTimeSpecificChartCountsChanges
        );
    }
    return newState;
}

export function getCorrespondingCountKeyForPieChartCategory(pieChartCategory) {
    switch(pieChartCategory){
        case POSITIVE + MENTIONS_LABEL:
            return POSITIVE;
        case NEGATIVE + MENTIONS_LABEL:
            return NEGATIVE;
        case NEUTRAL + MENTIONS_LABEL:
            return NEUTRAL;
        case VERY_POSITIVE + MENTIONS_LABEL:
            return VERY_POSITIVE_KEY_FOR_CHART_COUNT_CHANGES;
        case VERY_NEGATIVE + MENTIONS_LABEL:
            return VERY_NEGATIVE_KEY_FOR_CHART_COUNT_CHANGES;
        default:
            return pieChartCategory;
    }
}

export function updateEmotionPieChartTotalCount(
    newState,
    chartId,
    relevance,
    nonDateTimeSpecificChartCountsChanges
) {
    const totalCountExcludingNeutralComments = nonDateTimeSpecificChartCountsChanges[TOTAL] - nonDateTimeSpecificChartCountsChanges[NEUTRAL];
    if (relevance) {
        newState[chartId].count += totalCountExcludingNeutralComments;
    }
    else {
        newState[chartId].count -= totalCountExcludingNeutralComments;
    }  
    
    return newState;
}

export function updateSentimentAndAvailableSourcesPieChartsTotalCount(
    newState,
    chartId,
    relevance,
    nonDateTimeSpecificChartCountsChanges
) {
    if (relevance) {
        newState[chartId].count += nonDateTimeSpecificChartCountsChanges[TOTAL];
    }
    else {
        newState[chartId].count -= nonDateTimeSpecificChartCountsChanges[TOTAL];
    }  
    return newState;
}

export function updateAvailableSourcesPieChart(
    state,
    chartId,
    relevance,
    source,
    nonDateTimeSpecificChartCountsChanges
) {
    let newState = JSON.parse(JSON.stringify(state));
    for (const categoryElement of newState[chartId].data) {
        if (source === categoryElement[0].toLowerCase()) {
            if (relevance) {
                categoryElement[1] = parseInt(categoryElement[1], PARSE_INT_RADIX) + nonDateTimeSpecificChartCountsChanges[TOTAL];
                break;
            }
            else {
                categoryElement[1] = parseInt(categoryElement[1], PARSE_INT_RADIX) - nonDateTimeSpecificChartCountsChanges[TOTAL];
                break;
            }  
        }
    }
    newState = updateSentimentAndAvailableSourcesPieChartsTotalCount(
        newState,
        chartId,
        relevance,
        nonDateTimeSpecificChartCountsChanges
    );
    return newState;
}

export function updateEmotionOrSentimentBarCharts (
    state,
    chartId,
    relevance,
    nonDateTimeSpecificChartCountsChanges
) {
    let newState = JSON.parse(JSON.stringify(state));
    let i = 0;
    for (const categoryElement of newState[chartId].categories) {
        const countToUpdateChart = nonDateTimeSpecificChartCountsChanges[categoryElement.toLowerCase()];
        if (relevance) {
            newState[chartId].values[i] = parseInt(newState[chartId].values[i], PARSE_INT_RADIX) + countToUpdateChart;
        }
        else {
            newState[chartId].values[i] = parseInt(newState[chartId].values[i], PARSE_INT_RADIX) - countToUpdateChart;
        }   
        i += 1;
    }
    return newState;
}

export function isTrendOrPercentageTrendChartWithData(chartId, state) {
    return (
        (EMOTION_OR_SENTIMENT_TREND_CHART_IDS.includes(chartId) || EMOTION_OR_SENTIMENT_PERCENTAGE_TREND_CHART_IDS.includes(chartId))
        && state[chartId].length > 0
    );
}

export function updateEmotionOrSentimentTrendCharts(
    state,
    chartId,
    relevance,
    trendChartCountChanges
) {
    let newState = JSON.parse(JSON.stringify(state));
    const chartTypeKey = getChartTypeKeyForTrendCharts(chartId);
    for (const categoryElement of newState[chartId]) {
        const category = categoryElement.category;
        for (const dataElement of categoryElement.data) {
            const dateTimeString = String(dataElement[0]);
            const countToUpdateChart = getEmotionOrSentimentCountForSpecificDate(
                trendChartCountChanges,
                dateTimeString,
                chartTypeKey,
                category
            );
            
            if (relevance) {
                dataElement[1] = parseInt(dataElement[1], PARSE_INT_RADIX) + countToUpdateChart;
            }
            else {
                dataElement[1] = parseInt(dataElement[1], PARSE_INT_RADIX) - countToUpdateChart;
            }
        }
    }
    return newState;
}

export function getChartTypeKeyForTrendCharts(
    chartId
) {
    if (chartId === SENTIMENT_TREND_CHART_ID || chartId === SENTIMENT_PERCENTAGE_TREND_CHART_ID) {
        return SENTIMENTS;
    }
    else {
        return EMOTIONS;
    }
}

export function getEmotionOrSentimentCountForSpecificDate(
    trendChartCountChanges,
    dateTimeString,
    chartTypeKey,
    category
) {
    if (!trendChartCountChanges[dateTimeString]) {
        return 0;
    }
    if (category === TOTAL) {
        return trendChartCountChanges[dateTimeString][TOTAL];
    }
    else {
        return trendChartCountChanges[dateTimeString][chartTypeKey][category];
    }
}

export function isSubTopicClustersChartWithData(chartId, state) {
    return (SUB_TOPIC_CLUSTERS_CHART_IDS.includes(chartId) && state[chartId].subTopics && state[chartId].subTopics.length > 0);
}

export function updateSubTopicClustersChart(
    state,
    chartId,
    relevance,
    subTopicChartCountChanges
) {
    let newState = JSON.parse(JSON.stringify(state));
    let subTopicsWithChanges = Object.keys(subTopicChartCountChanges);
    let totalClassifiedCommentCount = 0;
    for (let subTopic of newState[chartId].subTopics) {
        let subTopicIdString = String(subTopic.id);
        if (!subTopicsWithChanges.includes(subTopicIdString)) {
            continue;
        }
        let subTopicCountChanges = subTopicChartCountChanges[subTopicIdString];
        totalClassifiedCommentCount += subTopicCountChanges.subTopicTotalCommentCount;
        if (relevance) {
            subTopic.subTopicTotalCommentCount                 += subTopicCountChanges.subTopicTotalCommentCount;
            subTopic.emotionCommentCounts[ANGER]               += subTopicCountChanges.emotionCommentCounts[ANGER];
            subTopic.emotionCommentCounts[JOY]                 += subTopicCountChanges.emotionCommentCounts[JOY];
            subTopic.emotionCommentCounts[FEAR]                += subTopicCountChanges.emotionCommentCounts[FEAR];
            subTopic.emotionCommentCounts[SADNESS]             += subTopicCountChanges.emotionCommentCounts[SADNESS];
            subTopic.emotionCommentCounts[NO_SPECIFIC_EMOTION] += subTopicCountChanges.emotionCommentCounts[NO_SPECIFIC_EMOTION];
        }
        else {
            subTopic.subTopicTotalCommentCount                 -= subTopicCountChanges.subTopicTotalCommentCount;
            subTopic.emotionCommentCounts[ANGER]               -= subTopicCountChanges.emotionCommentCounts[ANGER];
            subTopic.emotionCommentCounts[JOY]                 -= subTopicCountChanges.emotionCommentCounts[JOY];
            subTopic.emotionCommentCounts[FEAR]                -= subTopicCountChanges.emotionCommentCounts[FEAR];
            subTopic.emotionCommentCounts[SADNESS]             -= subTopicCountChanges.emotionCommentCounts[SADNESS];
            subTopic.emotionCommentCounts[NO_SPECIFIC_EMOTION] -= subTopicCountChanges.emotionCommentCounts[NO_SPECIFIC_EMOTION];
        }
    }
    newState = updateSubTopicClustersChartTotalCount(
        newState,
        chartId,
        relevance,
        totalClassifiedCommentCount
    );
    return newState;
}

export function updateSubTopicClustersChartTotalCount(
    newState,
    chartId,
    relevance,
    totalClassifiedCommentCount
) {
    if (relevance) {
        newState[chartId].count += totalClassifiedCommentCount;
    }
    else {
        newState[chartId].count -= totalClassifiedCommentCount;
    }  
    return newState;
}


// WEBPACK FOOTER //
// ./src/features/shared-components/chart/redux/updateChartForRelevanceUpdatesOfPostService.js